module.exports = __webpack_public_path__ + "img/458.9beb7262.png";